const e=({constants:t})=>({styleOverrides:{root:{minWidth:"auto",width:t.listItemIconWidth}}});export{e as default};
